import SVGInjector from './svg-injector.js';
export default SVGInjector;